export default "__VITE_ASSET__CPgPJ2AM__"